import { render, staticRenderFns } from "./chuku_show.vue?vue&type=template&id=2da47f50&scoped=true"
import script from "./chuku_show.vue?vue&type=script&lang=js"
export * from "./chuku_show.vue?vue&type=script&lang=js"
import style0 from "./chuku_show.vue?vue&type=style&index=0&id=2da47f50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da47f50",
  null
  
)

export default component.exports